<template>
  <button
    class="mdc-button cvt-mdc-button"
    :class="styleClasses"
    :disabled="disabled"
    @click="onClick"
  >
    <span
      v-if="iconTrailing"
      class="mdc-button__label"
    ><slot /></span>
    <i
      v-if="icon"
      class="material-icons mdc-button__icon"
      aria-hidden="true"
      v-text="icon"
    />
    <span
      v-if="!iconTrailing"
      class="mdc-button__label"
    ><slot /></span>
  </button>
</template>

<script>
import { MDCRipple } from '@material/ripple'
export default {
  name: 'MaterialButton',

  props: {
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    shaped: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    raised: {
      type: Boolean,
      default: false
    },
    unelevated: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconTrailing: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {}
  },

  computed: {
    styleClasses () {
      return {
        'mdc-button--outlined': this.outlined,
        'mdc-button--raised': this.raised,
        'mdc-button--unelevated': this.unelevated,
        'mdc-button--dense': this.dense,
        'mdc-button--shaped': this.shaped,
        'mdc-button--fullwidth': this.fullWidth
      }
    }
  },

  mounted () {
    this.initRipple()
  },

  updated () {
    this.initRipple()
  },

  methods: {
    onClick () {
      this.$emit('click')
    },
    initRipple () {
      if (this.ripple) this.ripple.destroy()
      this.ripple = new MDCRipple(this.$el)
    }
  }
}
</script>

<style lang="scss">
@import "./variables.scss";
@import "@material/button/mdc-button";

.mdc-button--shaped {
  @include mdc-button-shape-radius(25px)
}

.mdc-button--fullwidth {
  width: 100%;
}
</style>
